import React, {useCallback, useEffect, useState} from 'react'
import {withStyles} from '@material-ui/core';
import styles from './styles'
import {withTranslation} from 'react-i18next';
import {compose} from 'recompose';
import PropTypes from 'prop-types';
import useShipperOptions from 'hooks/useShipperOptions';
import {LoadingWrapper, TextPlaceholderWrapper} from 'components';
import {getDayNumberByDayOfWeek} from 'services/enums/dayOfWeekHelper';
import {displayModes} from 'services/enums/displayModes';
import useCarriersWithHubs from 'hooks/useCarriersWithHubs';
import {TemplateStopService} from '../../../services/backend/templateStopService';
import TemplateOverview from '../TemplateOverview';

// This is a modified Template view to easily work with templateStops
// This view will only work as admin, since it requires loading templates and template stops without the carrier filter
function TemplateStopTemplateOverview(props) {
  const { classes, t, filter, displayMode } = props;

  const [templates, setTemplates] = useState([]);
  const [templateStops, setTemplateStops] = useState([]);
  const [backendLoadingTemplates, setBackendLoadingTemplates] = useState(false);
  const [backendLoadingTemplateStops, setBackendLoadingTemplateStops] = useState(false);
  const { shipperOptions } = useShipperOptions();
  const { carriersWithHubs } = useCarriersWithHubs(filter.carrierName);

  const loadTemplates = useCallback(async (withLoadingIndicator = true) => {
    if (withLoadingIndicator) setBackendLoadingTemplates(true);
    try {
      const templates = await TemplateStopService.getTemplatesWithStopsAndDurationsByFilter({
        dayOfWeek: getDayNumberByDayOfWeek(filter.dayOfWeek),
        shipperName: filter.shipperName,
        carrierName: filter.carrierName,
        microHubName: filter.microHubName
      });
      setTemplates(templates);
      if (withLoadingIndicator) setBackendLoadingTemplates(false);
    } catch (error) {
      alert(`${t('errorLoadingTourTemplates')}, ${error}`);
      if (withLoadingIndicator) setBackendLoadingTemplates(false);
    }
  }, [filter, t]);

  const loadTemplateStops = useCallback(async () => {
    setBackendLoadingTemplateStops(true);
    try {
      const templateStops = await TemplateStopService.getTemplateStopsWithFilter(filter);
      setTemplateStops(templateStops);
      setBackendLoadingTemplateStops(false);
    } catch (e) {
      alert(`${t('errorLoadingTemplateStops')}, ${e}`);
      setBackendLoadingTemplateStops(false);
    }
  }, [filter, t])

  useEffect(() => {
    if (!filter.dayOfWeek || !filter.shipperName) return;
    loadTemplates();
    loadTemplateStops();
  }, [loadTemplates, loadTemplateStops, filter]);

  return (
    <div>
      <div className={classes.root}>
        <LoadingWrapper loading={backendLoadingTemplates || backendLoadingTemplateStops}>
          <TextPlaceholderWrapper
            active={!filter.dayOfWeek || !filter.shipperName}
            text={t('tourTemplatesNoWeekDayAndShipperSelected')}
          >
            <TemplateOverview
              carrierWithMicroHubs={carriersWithHubs}
              displayMode={displayMode}
              filter={filter}
              reloadTemplates={loadTemplates}
              setTemplates={setTemplates}
              shipperOptions={shipperOptions}
              templates={templates}
              templateStops={templateStops}
            />
          </TextPlaceholderWrapper>
        </LoadingWrapper>
      </div>
    </div>
  );
}

TemplateStopTemplateOverview.propTypes = {
  filter: PropTypes.object.isRequired,
  displayMode: PropTypes.oneOf(Object.values(displayModes)).isRequired,
  classes: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};


export default compose(withStyles(styles), withTranslation())(TemplateStopTemplateOverview);
